import { Controller } from 'stimulus'

// Handles restoring <input> original state and clearing validation errors.
// To set the original 'value' of an input, set 'data-original-value'. If not
// set, the value will simply be cleared.
export default class extends Controller {
  static targets = ['input']

  connect() {
    this.element[this.identifier] = this
  }

  resetState() {
    this.restoreInputValue()
    this.removeValidationErrors()
  }

  restoreInputValue() {
    this.inputTargets.forEach((input) => {
      input.value = input.getAttribute('data-original-value')
    })
  }

  removeValidationErrors() {
    this.inputTargets.forEach((input) => {
      const inputContainer = input.parentElement

      inputContainer.classList.remove('is-invalid')
      inputContainer.querySelector('.particle-live-region')?.remove()
    })
  }
}
